import * as Sentry from "@sentry/nextjs"

import useToast from "@hooks/useToast"
import { ParticipationDetailsFormAttributes } from "@modules/tenants/OrdersPage/Components/AddOrderModal/ParticipationDetailsForm/ParticipationDetailsForm"
import { useUpdatePerParticipantFieldsOfOrderMutation } from "@mono/essentials/entities/order/hooks"
import {
  GetOrderDetailsResponseType,
  UpdatePerParticipantFieldsOfOrderRequestType,
} from "@mono/essentials/types/OrderTypes"

export const useHandleUpdateParticipantDetailsOfOrderItem = () => {
  const { showToast } = useToast()
  const { mutateAsync: updatePerParticipantFieldsOfOrderMutation } =
    useUpdatePerParticipantFieldsOfOrderMutation()

  const handleUpdateParticipantDetailsOfOrderItem = async ({
    formValues,
    orderData,
    orderItemId,
    onSuccess,
    onError,
  }: {
    orderItemId: string
    formValues: ParticipationDetailsFormAttributes
    orderData: GetOrderDetailsResponseType
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
  }) => {
    try {
      if (formValues?.participantsDetails && orderData?.id && orderItemId) {
        const updatedParticipantsPayload: UpdatePerParticipantFieldsOfOrderRequestType[] = []
        formValues?.participantsDetails?.forEach((participantDetails) => {
          Object.keys(participantDetails)
            .filter(
              (fieldName) =>
                !(
                  fieldName.includes("_id") ||
                  fieldName === "participantUnitId" ||
                  fieldName === "participantGroupName" ||
                  fieldName === "participantId" ||
                  fieldName === "participantIndex" ||
                  fieldName === "id"
                )
            )
            .forEach((fieldName) =>
              updatedParticipantsPayload.push({
                id: participantDetails[`${fieldName}_order_item_field_id`]
                  ? (participantDetails[`${fieldName}_order_item_field_id`] as string)
                  : undefined,
                field_id: participantDetails[`${fieldName}_id`] as string,
                order_item_id: orderItemId,
                booking_participant_id: participantDetails.participantId as string,
                value: participantDetails[fieldName],
              })
            )
        })
        if (updatedParticipantsPayload.length) {
          await updatePerParticipantFieldsOfOrderMutation({
            orderId: orderData?.id,
            body: updatedParticipantsPayload,
          })
          await onSuccess?.()
        } else {
          showToast({
            heading: "No fields data found! please try again later.",
            type: "danger",
          })
        }
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleUpdateParticipantDetailsOfOrderItem }
}
